/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  AccommodationBookingObjectDto
} from '../../models'
import { customInstance } from '../../../utils/mutator/custom-instance';
import type { ErrorType } from '../../../utils/mutator/custom-instance';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId = (
    objectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AccommodationBookingObjectDto>(
      {url: `/umbraco/taf-delivery/api/v1/booking-objects/item/${objectId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdQueryKey = (objectId: string,) => {
    return [`/umbraco/taf-delivery/api/v1/booking-objects/item/${objectId}`] as const;
    }

    
export const getGetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>, TError = ErrorType<unknown>>(objectId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdQueryKey(objectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>> = ({ signal }) => getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId(objectId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(objectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>>
export type GetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdQueryError = ErrorType<unknown>



export function useGetUmbracoTafDeliveryApiV1BookingObjectsItemObjectId<TData = Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>, TError = ErrorType<unknown>>(
 objectId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdQueryOptions(objectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>, TError = ErrorType<unknown>>(objectId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdQueryKey(objectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>> = ({ signal }) => getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId(objectId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>>
export type GetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdSuspenseQueryError = ErrorType<unknown>



export function useGetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdSuspense<TData = Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>, TError = ErrorType<unknown>>(
 objectId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsItemObjectId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdSuspenseQueryOptions(objectId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren = (
    dockumentKey: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AccommodationBookingObjectDto[]>(
      {url: `/umbraco/taf-delivery/api/v1/booking-objects/list/${dockumentKey}/children`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenQueryKey = (dockumentKey: string,) => {
    return [`/umbraco/taf-delivery/api/v1/booking-objects/list/${dockumentKey}/children`] as const;
    }

    
export const getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenQueryOptions = <TData = Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>, TError = ErrorType<unknown>>(dockumentKey: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenQueryKey(dockumentKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>> = ({ signal }) => getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren(dockumentKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(dockumentKey), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenQueryResult = NonNullable<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>>
export type GetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenQueryError = ErrorType<unknown>



export function useGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren<TData = Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>, TError = ErrorType<unknown>>(
 dockumentKey: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenQueryOptions(dockumentKey,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>, TError = ErrorType<unknown>>(dockumentKey: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenQueryKey(dockumentKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>> = ({ signal }) => getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren(dockumentKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>>
export type GetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenSuspenseQueryError = ErrorType<unknown>



export function useGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenSuspense<TData = Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>, TError = ErrorType<unknown>>(
 dockumentKey: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildren>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenSuspenseQueryOptions(dockumentKey,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants = (
    dockumentKey: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AccommodationBookingObjectDto[]>(
      {url: `/umbraco/taf-delivery/api/v1/booking-objects/list/${dockumentKey}/decendants`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsQueryKey = (dockumentKey: string,) => {
    return [`/umbraco/taf-delivery/api/v1/booking-objects/list/${dockumentKey}/decendants`] as const;
    }

    
export const getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsQueryOptions = <TData = Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>, TError = ErrorType<unknown>>(dockumentKey: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsQueryKey(dockumentKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>> = ({ signal }) => getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants(dockumentKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(dockumentKey), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsQueryResult = NonNullable<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>>
export type GetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsQueryError = ErrorType<unknown>



export function useGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants<TData = Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>, TError = ErrorType<unknown>>(
 dockumentKey: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsQueryOptions(dockumentKey,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>, TError = ErrorType<unknown>>(dockumentKey: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsQueryKey(dockumentKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>> = ({ signal }) => getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants(dockumentKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>>
export type GetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsSuspenseQueryError = ErrorType<unknown>



export function useGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsSuspense<TData = Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>, TError = ErrorType<unknown>>(
 dockumentKey: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendants>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsSuspenseQueryOptions(dockumentKey,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



